import {instance, onErrorFunction, onSuccessFunction} from "../../../config/axios-cnf";

export const apiGetFaceRecognitionStats = (subjectId, dateFrom, dateTo, callback, error) => {
    instance.get("/api/v2/enigoo/" + subjectId + "/face-recognition/stats", {
        params: {dateFrom, dateTo}
    })
        .then(response => callback(onSuccessFunction(response.data)))
        .catch(err => error(onErrorFunction(err)));
};
